/// <amd-module name="Wit/MarkdownEditorReduxAdapter/Redux/MarkdownEditorSelector" />
import * as Reselect from "Reselect";
import { IMarkdownEditorAwareState, IMarkdownEditorKey } from "Wit/MarkdownEditorReduxAdapter/Redux/MarkdownEditorContracts";

const _getMarkdownState = (state: IMarkdownEditorAwareState) => {
    return state || {};
};

const _getMarkdownStateMap = (state: IMarkdownEditorAwareState) => {
    const markdownState = _getMarkdownState(state);
    return markdownState.markdownStateMap || {};
};

const _getMarkdownStatesByWorkItemId = (state: IMarkdownEditorAwareState, workItemId: number) => {
    const markdownStateMap = _getMarkdownStateMap(state);
    return markdownStateMap[workItemId] || {};
};

const _getMarkdownStateByKey = (state: IMarkdownEditorAwareState, key: IMarkdownEditorKey) => {
    const workItemState = _getMarkdownStatesByWorkItemId(state, key.workItemId);
    return workItemState[key.fieldRefName] || {};
};

const _getMarkdownEditorValueByKey = (state: IMarkdownEditorAwareState, key: IMarkdownEditorKey) => {
    const markdownEditorStateByKey = _getMarkdownStateByKey(state, key);
    return markdownEditorStateByKey.editorValue || "";
};

const _areMarkdownEditorValuesEmpty = (state: IMarkdownEditorAwareState, workItemId: number) => {
    const workItemStates = _getMarkdownStatesByWorkItemId(state, workItemId);
    const fieldRefNames = Object.keys(workItemStates);
    return fieldRefNames.every(fieldRefName => isMarkdownEditorValueEmpty(state, { workItemId, fieldRefName }));
};

export const getMarkdownEditorValueByKey = Reselect.createSelector(_getMarkdownEditorValueByKey, value => value);

export const getMarkdownStateByKey = Reselect.createSelector(_getMarkdownStateByKey, markdownState => markdownState);

export const isMarkdownEditorValueEmpty = Reselect.createSelector(_getMarkdownEditorValueByKey, value => value.trim() === "");

export const areMarkdownEditorValuesEmpty = Reselect.createSelector(_areMarkdownEditorValuesEmpty, value => value);